var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ckeditor',{attrs:{"editor":_vm.editor,"config":_vm.editorConfig},on:{"input":_vm.onEditorInput},model:{value:(_vm.localStatuteData),callback:function ($$v) {_vm.localStatuteData=$$v},expression:"localStatuteData"}})}
var staticRenderFns = []

export { render, staticRenderFns }